import { Grid } from "@material-ui/core";
import React from "react";
import { EnumChartAction } from "../types";
import Action from "./Action";
import SelectorGroupBy from "./SelectorGroupBy";
import SelectorGroupByPeriod from "./SelectorGroupByPeriod";
import { ActionsFC } from "./types";

const Actions: ActionsFC = ({ actions }) => (
  <Grid container spacing={2}>
    {actions.map((action, i) => {
      switch (action) {
        case EnumChartAction.GROUP_BY:
          return (
            <Action title={"Группировать по:"} key={i}>
              <SelectorGroupBy key={action} />
            </Action>
          );
        case EnumChartAction.GROUP_BY_PERIOD:
          return (
            <Action title={"Группировать по:"} key={i}>
              <SelectorGroupByPeriod key={action} />
            </Action>
          );
        // case EnumChartAction.PERIOD:
        //   return (
        //     <Action title={"Период:"}>
        //       <SelectorPeriod key={action} />
        //     </Action>
        //   );
      }
    })}
  </Grid>
);

export default Actions;
